// extracted by mini-css-extract-plugin
export var alert = "alert-module--alert--iIFPs";
export var alertContent = "alert-module--alertContent--OTdB2";
export var alertIcon = "alert-module--alertIcon--FG187";
export var alertInfo = "alert-module--alertInfo--fOyvm";
export var alertWarning = "alert-module--alertWarning--JeeKh";